import {
  GetBuildingSearchReqObj,
  GetBuildingSearchResObj
} from '@gateway.Building'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface BuildingSearchState {
  /** 検索条件 */
  buildingSearchCondition: GetBuildingSearchReqObj
  buildingSearchData: GetBuildingSearchResObj
}

const BUILDING_SEARCH_CONDITION: GetBuildingSearchReqObj = {
  procurementNo: '',
  buildingNo: '',
  obtainFyList: [],
  obtainHistoryCdList: [],
  constructionFormCdList: [],
  evaluationValueCdList: [],
  effortLevelCdList: [],
  choiceAndConcentrationTarget: [],
  procurementStsList: [],
  updStsList: [],
  yamadumiFlg: [],
  kenzaiDiscloseFlg: [],
  supplierDiscloseFlg: [],
  completedFlg: [],
  reportNonTargetFlg: [],
  updUserKbn: [],
  updUserStr: '',
  updDateFrom: '',
  updDateTo: '',
  branchCdList: [],
  constructionNm: '',
  constructionNmDuplication: [],
  constructionSectionNm: '',
  chiefPersonNm: '',
  hqSalesSectionNm: '',
  hqSalesPersonNm: '',
  branchSalesSectionNm: '',
  branchSalesPersonNm: '',
  totalCostFrom: 0,
  totalCostTo: 0,
  ourCompanyTotalCostFrom: 0,
  ourCompanyTotalCostTo: 0,
  scheduleYFrom: '',
  scheduleYTo: '',
  constructionCdList: [],
  architectureUse: '',
  structureUndergroundList: [],
  structureGroundList: [],
  specialConstructionMethod: '',
  remark: '',
  expenseOnCdList: [],
  expenseOffCdList: [],
  sortOrder: '1',
  constructionSubjectCdExist: [],
  sagyosyoCdExist: [],
  buildingNoExist: []
}

const BUILDING_SEARCH_DATA: GetBuildingSearchResObj = {
  buildingInfoList: []
}

const initialState: BuildingSearchState = {
  buildingSearchCondition: BUILDING_SEARCH_CONDITION,
  buildingSearchData: BUILDING_SEARCH_DATA
}

const buildingSearchSlice = createSlice({
  name: 'buildingsearch',
  initialState,
  reducers: {
    setBuildingSearchCondition: (
      state,
      action: PayloadAction<BuildingSearchState['buildingSearchCondition']>
    ) => {
      state.buildingSearchCondition = action.payload
    },
    setBuildingSearchData: (
      state,
      action: PayloadAction<BuildingSearchState['buildingSearchData']>
    ) => {
      state.buildingSearchData = action.payload
      state.buildingSearchData.buildingInfoList = state.buildingSearchData.buildingInfoList.map((item) => {
        item.buildingInfo.isExpanded = true
        return item
      })
    }
  }
})

export const BuildingSearchActions = buildingSearchSlice.actions
export const BuildingSearchReducers = buildingSearchSlice.reducer
